export const radius200 = "3px";
export const radius300 = "4px";
export const radius400 = "6px";
export const radius500 = "8px";
export const radius900 = "999999px";
export const radiusRound = "999999px";
export const width0 = "0px";
export const width400 = "1px";
export const width500 = "2px";